import styled from "styled-components"

export const Content = styled.span`
  font-size: 16px;
  line-height: 24px;
  color: #303036;
  ${(props) => props}
`

const Text = (props) => {
  return <Content {...props}>{props.children}</Content>
}

export default Text
